<dcr-card
  class="[ h-full ]"
  [headline]="student.displayName"
  header-orientation="horizontal"
  [ariaSelected]="selected"
  [elevated]="selected"
  [attr.color]="selected ? 'secondary' : undefined"
  [subhead]="isSmartschool ? 'Smartschool' : undefined"
  data-cy="student-card"
  >
  <div slot="avatar">
    <dcr-avatar
      [firstName]="student.firstName"
      [lastName]="student.name"
      [imageUrl]="student.avatar"
      [showInitials]="!student.avatar"
      readonly
    ></dcr-avatar>
  </div>

  @if (!isSmartschool && selectable) {
    <div slot="header-action">
      <dcr-checkbox [checked]="selected" (change)="toggleSelectStudent()"></dcr-checkbox>
    </div>
  }

  <div slot="content" class="[ stack stack-space-s ][ p-i-s p-b-xs ]">
    <div class="[ flex items-center gap-2xs ]">
      <dcr-icon icon="ui:class" size="xs"></dcr-icon>

      @if (!!groupNames && !showPreviousClassGroupName) {
        <span class="[ line-clamp-2 ]">
          {{ groupNames.length ? groupNames.join(', ') : 'geen klasgroep' }}
        </span>
      }

      @if (showPreviousClassGroupName) {
        <span class="[ line-clamp-2 ]">
          {{ previousClassGroupName ? 'vorige klas: ' + previousClassGroupName : 'geen vorige klas' }}
        </span>
      }
    </div>

    <div class="[ stack stack-space-3xs ]">
      @if (!!leerId) {
        <div class="[ flex items-center gap-2xs ][ body-small ][ truncate ]">
          <dcr-icon icon="ui:leerid" size="xs"></dcr-icon>
          <span class="[ truncate ]">
            Leerid: <strong>{{ leerId }}</strong>
          </span>
        </div>
      }

      @if (!!personalCode) {
        <div class="[ flex items-center gap-2xs ][ body-small ]">
          <dcr-icon icon="ui:password" size="xs"></dcr-icon>
          <span>
            Wachtwoord: <strong>{{ personalCode }}</strong>
          </span>
        </div>
      }

      @if (coins | number) {
        <div class="[ flex items-center gap-2xs ][ body-small ]">
          <dcr-icon icon="ui:kwetons" size="xs"></dcr-icon>
          <span>
            Kwetons: <strong>{{ coins }}</strong>
          </span>
        </div>
      }

      @if (lastLogin) {
        <div class="[ flex items-center gap-2xs ][ body-small ]">
          <dcr-icon icon="ui:login" size="xs"></dcr-icon>
          <span>
            Laatst aangemeld op <strong>{{ lastLogin | humanDateTime: { format: 'numericDateTime' } }}</strong>
          </span>
        </div>
      }
    </div>
  </div>

  <div slot="actions">
    @if (action) {
      <dcr-inline-button
        campusClickStopPropagation
        campusClickPreventDefault
        [label]="action.label"
        [routerLink]="action.routerLink"
        (click)="actionClicked()"
        [attr.leading-icon]="'ui:' + action.svgIcon"
        >
      </dcr-inline-button>
    }
    <ng-content select="campus-student-card-actions"></ng-content>
  </div>
</dcr-card>
